import { defineMessages } from "react-intl";

export default defineMessages({
  total: {
    id: "Appointment.AppointmentSummaryMobile.total",
    defaultMessage: "Total",
  },
});
